<template>
  <section
    class="md:mt-8 m-auto bg-black pt-6 px-2 md:px-10 pb-10 shadow-black shadow-xl max-w-[1400px]"
  >
    <div
      class="w-full text-white font-electro flex flex-col text-center items-center pt-12 md:pt-8 pb-8 gap-6"
    >
      <h1 class="font-russo text-[#FF0000] text-[28px] md:text-[40px] uppercase">
        Pay with WeChat Pay / Alipay
      </h1>
      <p class="font-russo text-[22px] md:text-[30px]">微信支付 / 支付宝</p>

      <p class="text-[18px] md:text-[22px] max-w-[820px]">
        No credit card needed. Get a full year of Rally Navigator using WeChat
        Pay or Alipay — a one-time payment that activates automatically.
      </p>
      <p class="text-[16px] md:text-[18px] max-w-[820px] text-[#F3EEEE]">
        无需信用卡。使用微信支付或支付宝即可购买一年的 Rally Navigator
        会员——一次性付款，自动激活。
      </p>

      <!-- Account email: prefilled into checkout so the membership activates on
           the right account (avoids the email-mismatch problem). -->
      <div class="w-full max-w-[520px] flex flex-col gap-2 text-left mt-2">
        <label for="rn-email" class="font-russo text-[15px] uppercase">
          Your Rally Navigator email · 您的账户邮箱
        </label>
        <input
          id="rn-email"
          v-model.trim="email"
          type="email"
          inputmode="email"
          autocomplete="email"
          placeholder="you@example.com"
          class="w-full px-4 py-3 rounded bg-[#111] border border-[#333] text-white text-[16px] focus:outline-none focus:border-[#FF0000]"
          @blur="touched = true"
        />
        <p class="text-[13px] md:text-[14px] text-[#F3EEEE]">
          Use the email you sign in to Rally Navigator with, so your membership
          activates on the correct account.<br />
          请填写您登录 Rally Navigator 的邮箱，以便会员正确激活到您的账户。
        </p>
        <p v-if="touched && !emailValid" class="text-[#FF0000] text-[14px]">
          Please enter a valid email. 请输入有效的邮箱地址。
        </p>
      </div>

      <!-- Plans -->
      <div
        class="w-full flex flex-col md:flex-row gap-6 justify-center items-stretch mt-2 max-w-[900px]"
      >
        <div
          v-for="plan in plans"
          :key="plan.role"
          class="flex-1 border border-[#333] rounded-lg p-6 flex flex-col gap-3 items-center bg-[#0d0d0d]"
        >
          <h2 class="font-russo text-[#FF0000] text-[22px] uppercase">
            {{ plan.name }}
          </h2>
          <p class="text-[34px] font-russo leading-none">{{ plan.price }}</p>
          <p class="text-[15px] text-[#F3EEEE]">
            {{ plan.blurb }}<br />{{ plan.blurbZh }}
          </p>
          <button
            type="button"
            class="mt-2 w-full bg-[#FF0000] text-white font-russo uppercase px-4 py-3 rounded hover:opacity-90 transition-opacity"
            @click="pay(plan)"
          >
            Pay with WeChat / Alipay<br />
            <span class="text-[14px]">微信支付 / 支付宝</span>
          </button>
        </div>
      </div>

      <p class="text-[14px] text-[#F3EEEE] max-w-[820px] mt-2">
        One-time payment for 1 year — no auto-renewal. Access activates
        automatically within a few minutes of payment.<br />
        一次性付款，有效期一年，不自动续费。付款后几分钟内自动激活。
      </p>

      <p class="text-center mt-2 text-[16px]">
        Need help? 需要帮助？
        <a
          href="mailto:info@rallynavigator.com"
          class="text-[#FF0000] hover:underline decoration-[#FF0000]"
          >info@rallynavigator.com</a
        >
      </p>
    </div>
  </section>
</template>

<script>
export default {
  name: 'WechatPay',
  data() {
    return {
      email: '',
      touched: false,
      // One-time "1 Year Access" Stripe payment links (offer WeChat Pay + Alipay).
      plans: [
        {
          role: 'premium',
          name: 'Premium',
          price: '$49 / year',
          blurb: 'All Premium features for one year.',
          blurbZh: '一年高级会员功能。',
          link: '8x214g0cFfivdH0cLp24004',
        },
        {
          role: 'pro_rally',
          name: 'Pro Rally',
          price: '$199 / year',
          blurb: 'Everything in Pro Rally for one year.',
          blurbZh: '一年 Pro Rally 全部功能。',
          link: '5kQ9AM7F70nBgTch1F24003',
        },
      ],
    };
  },
  created() {
    // Allow the in-app "trouble paying?" link to prefill the account email via
    // ?email=... so the buyer doesn't retype it (and fulfillment matches).
    const q = this.$route && this.$route.query ? this.$route.query.email : '';
    if (typeof q === 'string' && q) this.email = q.trim();
  },
  computed: {
    emailValid() {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email);
    },
  },
  methods: {
    pay(plan) {
      this.touched = true;
      if (!this.emailValid) {
        const el = document.getElementById('rn-email');
        if (el) el.focus();
        return;
      }
      // Prefill the buyer's email so the webhook fulfills onto their account.
      const url = `https://buy.stripe.com/${plan.link}?prefilled_email=${encodeURIComponent(
        this.email
      )}`;
      window.location.href = url;
    },
  },
};
</script>
